// auto created file
export const text = {
  en: {
    welcome: " Welcome",
    totalEmployees: "Total Employees",
    activeEmployees: "Active Employees",
    onLeave: "On Leave",
    totalCompanies: "Total Companies",
    fromLastMonth: "from last month",
    thisWeek: "this week",
    today: "today",
    overall: "overall",
    departmentStats: "Department Statistics",
    recentActivity: "Recent Activity",
    totalAcrossDepts: "Total Employees Across All Departments",
    noActivities: "No recent activities found.",
    employees: "Employees",
      totalDepartments: "Total Departments",
  largestDepartment: "Largest Department",
  singleEmployeeDepartments: "Single Employee Departments",
  ofDepartments: "of departments",
  topDepartments: "Top 10 Departments",
  distribution: "Distribution",
  other: "Other",
  employee: "Employee",
  },
  ar: {
    welcome: "مرحبًا",
    totalEmployees: "إجمالي الموظفين",
    activeEmployees: "الموظفون النشطون",
    onLeave: "في إجازة",
    totalCompanies: "إجمالي الشركات",
    fromLastMonth: "من الشهر الماضي",
    thisWeek: "هذا الأسبوع",
    today: "اليوم",
    overall: "بشكل عام",
    departmentStats: "إحصائيات الأقسام",
    recentActivity: "الأنشطة الأخيرة",
    totalAcrossDepts: "إجمالي الموظفين في جميع الأقسام",
    noActivities: "لا توجد أنشطة حديثة.",
    employees: "موظفين",
    totalDepartments: "عدد الأقسام",
  largestDepartment: "أكبر قسم",
  singleEmployeeDepartments: "أقسام بموظف واحد",
  ofDepartments: "من الأقسام",
  topDepartments: "أكبر 10 أقسام",
  distribution: "توزيع",
  other: "أخرى",
  employee: "موظف",
  },
};